import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43a89185"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "EmailSupportButton"
}
const _hoisted_2 = {
  key: 0,
  style: {"color":"var(--color-grey-light)"}
}

import { Button } from '@/v2/shared/ui';


export default /*#__PURE__*/_defineComponent({
  __name: 'EmailSupportButton',
  props: {
  support_email: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: 'Tech support'
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (__props.support_email)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.text)
          ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(__props.text), 1))
          : _createCommentVNode("", true),
        _createVNode(_unref(Button), {
          href: 'mailto:' + __props.support_email,
          target: "_blank",
          type: 'link'
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.support_email), 1)
          ]),
          _: 1
        }, 8, ["href"])
      ]))
    : _createCommentVNode("", true)
}
}

})